import { Trans, useLingui } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Card } from '@startuptools/ui/Card';
import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { type GqlValidatorStatus } from '../../../graphql/base-types.graphql';

export const ValidatorErrorDialog = ({ errors, onClose }: { errors: GqlValidatorStatus[]; onClose: () => void }) => {
  const { i18n } = useLingui();

  return (
    <Modal open onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <Stack margin={3} gap={3}>
          <Typography level="h4">
            <Trans id="Errors were detected" />
          </Typography>
          <Alert>
            <Trans id="There are one or multiple problems that needs resolving before generating the document" />
          </Alert>

          <Card>
            <ul>
              {errors
                .filter(ve => ve.completed && ve.hasError)
                .map((ve, i) => {
                  return (
                    <li key={i}>
                      <Typography level="title-md">{ve.error?.[i18n.locale as 'sv' | 'en']?.short}</Typography>
                      <Typography>{ve.error?.[i18n.locale as 'sv' | 'en']?.long}</Typography>
                    </li>
                  );
                })}
            </ul>
          </Card>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
